import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import MoaStyledComponent from "../../Style/MoaStyled";
var StyledComponent = function (props) {
    var id = props.id, url = props.url, alt = props.alt, width = props.width, height = props.height;
    return (_jsx("img", { id: id, src: url, alt: alt, width: width, height: height }));
};
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
